import JsonUtils from '@/js/JsonUtils'

const _testKey = 'barTest'
const _testValue = 'test'
localStorage.setItem(_testKey, _testValue)
const _key = 'barCache'
const cache = {
  set(key, value) {
    if (this.isUseStorage()) {
      this.setStorage(key, value)
    } else {
      this.setCookie(key, value)
    }
  },
  get(key) {
    return this.isUseStorage() ? this.getStorage(key) : this.getCookie(key)
  },
  del(key) {
    if (this.isUseStorage()) {
      this.delStorage(key)
    } else {
      this.removeCookie(key)
    }
  },
  // localStorage
  setStorage(key, value) {
    let map = new Map()
    if (localStorage.getItem(_key) != null) {
      map = JsonUtils.jsonToMap(localStorage.getItem(_key))
    }
    map.set(key, value)
    localStorage.setItem(_key, JsonUtils.mapToJson(map))
  },
  getStorage(key) {
    let map = new Map()
    if (localStorage.getItem(_key) != null) {
      map = JsonUtils.jsonToMap(localStorage.getItem(_key))
    }
    return map.get(key)
  },
  delStorage(key) {
    let map = new Map()
    if (localStorage.getItem(_key) != null) {
      map = JsonUtils.jsonToMap(localStorage.getItem(_key))
    }
    if (map.has(key)) {
      map.delete(key)
      localStorage.setItem(_key, JsonUtils.mapToJson(map))
    }
  },
  // 判断localStorage是否可以用
  isUseStorage() {
    return localStorage.getItem(_testKey) === _testValue
  },
  // --Cookie
  setCookie(key, value, expiredays = 30) {
    let exdate = new Date()
    exdate.setDate(exdate.getDate() + expiredays)
    let map = new Map()
    if (this.getCookie(_key) != null) {
      map = JsonUtils.jsonToMap(this.getCookie(_key))
    }
    map.set(key, value)
    document.cookie = _key + '=' + escape(JsonUtils.mapToJson(map)) + (expiredays === null ? '' : ';expires=' + exdate.toGMTString())
  },
  getCookie(key) {
    let map = new Map()
    let value = this.getRootCookie()
    if (value !== '') {
      map = JsonUtils.jsonToMap(value)
    }
    return map.get(key)
  },
  // 取回cookie
  getRootCookie() {
    if (document.cookie.length > 0) {
      let startData = document.cookie.indexOf(_key + '=')
      if (startData !== -1) {
        startData = startData + _key.length + 1
        let endData = document.cookie.indexOf(';', startData)
        if (endData === -1) {
          endData = document.cookie.length
        }
        let value = unescape(document.cookie.substring(startData, endData))
        return value
      }
    }
    return ''
  },
  // 移除cookie
  removeCookie(key, expiredays = 30) {
    let map = new Map()
    let value = this.getRootCookie()
    if (value !== '') {
      map = JsonUtils.jsonToMap(value)
    }
    if (map.has(key)) {
      map.delete(key)
      let exdate = new Date()
      exdate.setDate(exdate.getDate() + expiredays)
      document.cookie = _key + '=' + escape(JsonUtils.mapToJson(map)) + (expiredays === null ? '' : ';expires=' + exdate.toGMTString())
    }
  }
}

export default cache



// WEBPACK FOOTER //
// ./src/js/cache.js